// Async-boundary entry — Module Federation requires that the shared scope
// initializes before any shared dep (React, single-spa, @unified-dashboard/*)
// is touched. `bootstrap.tsx` does the actual work.
import('./bootstrap.js').catch((err) => {
  console.error('[shell] bootstrap failed', err);
});
